import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusBillingStatusFragment = { readonly __typename?: 'SyncableEpocusBillingStatus', readonly id: string, readonly examId: string, readonly encounterId: string, readonly programId?: string | null, readonly performerId?: string | null, readonly status: Types.EpocusBillingState, readonly missingItems: ReadonlyArray<Types.EpocusBillingMissingItem>, readonly holdReason?: Types.EpocusBillingHoldReason | null, readonly qaAfterExport?: Types.EpocusBillingHoldReason | null, readonly amendedAfterExportAt?: string | null, readonly computedAt: string, readonly examType?: string | null, readonly examSignedAt?: string | null, readonly examCreatedAt?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusBillingStatusPullQueryVariables = Types.Exact<{
  input: Types.PullEpocusBillingStatusInput;
}>;


export type SyncEpocusBillingStatusPullQuery = { readonly __typename?: 'Query', readonly pullEpocusBillingStatus: { readonly __typename?: 'PullEpocusBillingStatusResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusBillingStatus', readonly id: string, readonly examId: string, readonly encounterId: string, readonly programId?: string | null, readonly performerId?: string | null, readonly status: Types.EpocusBillingState, readonly missingItems: ReadonlyArray<Types.EpocusBillingMissingItem>, readonly holdReason?: Types.EpocusBillingHoldReason | null, readonly qaAfterExport?: Types.EpocusBillingHoldReason | null, readonly amendedAfterExportAt?: string | null, readonly computedAt: string, readonly examType?: string | null, readonly examSignedAt?: string | null, readonly examCreatedAt?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusBillingStatusFragmentDoc = gql`
    fragment WholeSyncableEpocusBillingStatus on SyncableEpocusBillingStatus {
  id
  examId
  encounterId
  programId
  performerId
  status
  missingItems
  holdReason
  qaAfterExport
  amendedAfterExportAt
  computedAt
  examType
  examSignedAt
  examCreatedAt
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusBillingStatusPullDocument = gql`
    query SyncEpocusBillingStatusPull($input: PullEpocusBillingStatusInput!) {
  pullEpocusBillingStatus(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableEpocusBillingStatus
    }
  }
}
    ${WholeSyncableEpocusBillingStatusFragmentDoc}`;

/**
 * __useSyncEpocusBillingStatusPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusBillingStatusPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusBillingStatusPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusBillingStatusPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusBillingStatusPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusBillingStatusPullQuery, SyncEpocusBillingStatusPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusBillingStatusPullQuery, SyncEpocusBillingStatusPullQueryVariables>(SyncEpocusBillingStatusPullDocument, options);
      }
export function useSyncEpocusBillingStatusPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusBillingStatusPullQuery, SyncEpocusBillingStatusPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusBillingStatusPullQuery, SyncEpocusBillingStatusPullQueryVariables>(SyncEpocusBillingStatusPullDocument, options);
        }
export type SyncEpocusBillingStatusPullQueryHookResult = ReturnType<typeof useSyncEpocusBillingStatusPullQuery>;
export type SyncEpocusBillingStatusPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusBillingStatusPullLazyQuery>;
export type SyncEpocusBillingStatusPullQueryResult = Apollo.QueryResult<SyncEpocusBillingStatusPullQuery, SyncEpocusBillingStatusPullQueryVariables>;